
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LearningChartUnit from '@/components/organisms/LearningChartUnit.vue'
import { SystemChartDetail } from '@/models/SystemChart'

/**
 * 知識MAPの単元チャート部分
 */
@Component({
  components: {
    ImageBase,
    LearningChartUnit,
  },
})
export default class LearningChart extends Vue {
  /** 知識MAP詳細情報 */
  @Prop()
  private systemChartDetail!: SystemChartDetail
  /** 単元選択時のイベント */
  @Prop()
  private onSelectUnit!: (id: number) => void
}
